<gg-button size="sm" color="primary" class="remove-class-button" [disabled]="disabled" (clickEvent)="remove.emit()">
  <div class="remove-class-button__content"><gg-close-icon></gg-close-icon> Remove</div>
</gg-button>
